import React, { useEffect, useState } from "react";
import { Button, Container, Row } from 'react-bootstrap';
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Cookies, useCookies } from 'react-cookie';
import OtpInput from 'react-otp-input';
import { toast } from 'react-toastify'

import Header from "../Layout/header";
import Footer from "../Layout/footer";
import { FaArrowRight } from "react-icons/fa6";
import logocircle from "../Assets/logo-circle2.png";
import newsletter from "../Assets/newsletter-image3.png";
import config from '../helper/config';
import { NumberOnly, isEmpty, removeLoginToken } from '../helper/common';
import { userforget2FA, userLogin } from "../Axios/user.axios";
import { FaRegEye, FaRegEyeSlash  } from "react-icons/fa6";
import Subscriber from "../Layout/subscribe";
import { useDispatch, useSelector } from "react-redux";
import { Data_Section, LogOut } from "../redux/constants";
import CommonFunction from "../helper/commonfucnctioncomponet";

export default function Login() {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  const cookies = new Cookies();

  const initform = {
    EmailId: '',
    Password: '',
  };

  const initname = {
    EmailId: "Email-Id",
    Password: 'Password',
  }

  const [formdata, SetFormdata] = useState(initform);
  const [displayname, SetDisplayName] = useState(initname);
  const [Error, SetError] = useState({});
  const [IpAddress, SetIpAddress] = useState('');
  const [Page, SetPage] = useState('login');
  const [counter, setCounter] = useState(120);
  const [Otp, SetOTP] = useState('');
  const [ResendOtp, SetResendOtp] = useState(false);
  const [Timer, SetTimer] = useState({
    Minutes: 0,
    Seconds: 0,
  })
  const [DisableStatus, SetDisableStatus] = useState({})
  const [focusedfield, SetFocusedField] = useState([]);

  const [passwordType, setPasswordType] = useState("password");


  const dispatch = useDispatch();
  const userdata = useSelector((state)=>state?.LoginReducer?.User)
  const navigate = useNavigate()
  const commonfuncfile = CommonFunction()



  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text")
      return;
    }
    setPasswordType("password")
  }



  useEffect(() => {
    if (Page == 'Otp') {
      if (counter == 0) {
        SetPage('resend');
      }
      const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
      const seconds = String(counter % 60).padStart(2, 0);
      const minutes = String(Math.floor(counter / 60)).padStart(2, 0);
      SetTimer({
        Minutes: minutes,
        Seconds: seconds
      })
      return () =>
        clearInterval(timer);
    }
  }, [counter, Page]);

  const OnChange = (e) => {
    const { id, value } = e.target;
    SetFormdata({ ...formdata, ...{ [id]: value } });
  }

  const Loginclick = async () => {
    SetDisableStatus({ [Page]: true })
    var baseDomain = config.domainname;
    var expireAfter = new Date();
    expireAfter.setDate(expireAfter.getDate() + 7)
    let error = Validate();
    if (isEmpty(error)) {
      let senddata = Page == 'login' ? formdata : { ...((Page == 'Otp' || Page == "TFA") ? { Otp: Otp } : {}), ...{ EmailId: formdata.EmailId } };
      senddata.Type = Page;
      var Resp = await userLogin(senddata);
      console.log('userLogin_resp', Resp)
      if (Resp?.success == 'success') {
        if (Page == 'login' || Page == 'resend') {
          if(Resp?.data?.LoginType=='TFA'){
            SetOTP('');
            SetError({});
            if (Page == 'login') {
              SetFocusedField([]);
            }
            return SetPage('TFA');
          }
          setCounter(120)
          SetPage('Otp');
          SetOTP('');
          SetError({});
          if (Page == 'login') {
            SetFocusedField([]);
          }
        }
        if (Resp.token) {
          var LastReportGenerated = new Date(),
            baseDomain = config.domainname,
            expireAfter = new Date();

          //setting up  cookie expire date after a week
          expireAfter.setDate(expireAfter.getDate() + 7);

          //now setup cookie
          
          if (baseDomain == 'localhost') {
            // document.cookie = config.cookiename + "=" + Resp.token + "; path=/";
            document.cookie = config.cookiename + "=" + Resp.token + "; expires=" + expireAfter + "; path=/";
          }
          else {
            // document.cookie = config.cookiename + "=" + Resp.token + "; domain=" + baseDomain + "; path=/";
            document.cookie = config.cookiename + "=" + Resp.token + "; domain=" + baseDomain + "; expires=" + expireAfter + "; path=/";
          }
          if(Resp?.data){
            dispatch({
              type: Data_Section,
              Register_Section: {
                User: {
                  payload: Resp?.data
                },
              }
            })
          }
          if (Page == 'Otp') {
            SetTimer({ Minutes: 0, Seconds: 0 });
            SetPage('verified');
            setCounter(0)
            if(document.referrer){
             return  window.location.href = document.referrer
            }
            navigate('/profile')
            // setTimeout(()=>{
            //   window.close();
            // },1000)
          }
          if(Page == 'TFA'){
             if(document.referrer){
             return  window.location.href = document.referrer
            }
            navigate('/profile')
          }
        }
        toast.success(Resp.msg, 1000)
        SetDisableStatus({ [Page]: false })

      }
      else {
        SetDisableStatus({ [Page]: false })
        toast.error(Resp?.msg)
        if(Resp?.error){
          SetError(Resp?.error)
        }
      }
    }
    else {
      SetDisableStatus({ [Page]: false })
      SetError(error);
      toast("Fill the Correct datas", { type: 'error' })
    }
  }

  const Validate = () => {
    let error = {};
    if (Page == 'login') {
      (Object.keys(formdata)).map((val) => {
        if (isEmpty(formdata[val]) && displayname[val]) {
          error[val] = "Enter " + displayname[val];
        }
        else {
          if (val == 'EmailId') {
            if (!config.EMAIL.test(formdata[val])) {
              error[val] = "Enter Valid EmailId"
            }
          }
        }
      })
    }
    // if (Page == 'Otp' || Page == "TFA") {
    //   if (!config.NumOnly.test(Otp)) {
    //     error.Otp = "Enter Number Only"
    //   }
    // }
    return error
  }

  const cookieChangeListener = (name, value) => {
    checkCookie(config.cookiename)
    // SetTokendata(value)
  }

  function getCookie(cookieName) {
    let name = cookieName + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  async function checkCookie(cookieName) {
    let cookie = getCookie(cookieName);
    if (isEmpty(cookie)) {
      if (Page == 'verified') {
        cookies.removeChangeListener();
        dispatch({
          type : "Socket",
          "Socket":{
            "Socket":{
              data : {},
              connected : false
            }
          }
        })
        dispatch({
          type: LogOut,
        })
        navigate("/");
        toast.success('LogOut Successfully')
        SetPage('login')
      }
    }
    else {
      SetPage('verified')
      navigate('/profile')
    }
  }
  useEffect(() => {
    // cookies.addChangeListener(cookieChangeListener);
  }, [Page])

  useEffect(() => {
    const usertoken = ("; " + document.cookie).split(`; ${config.cookiename}=`).pop().split(";")[0];
    if (usertoken) {
      SetPage('verified')
    }
    UserLoginCheck()
  }, [])

  const UserLoginCheck = async () => {
    let resp = await commonfuncfile.UserCheck();
    if(resp?.status){
        navigate('/profile');
    }
}

  const LogOutClick = () => {
    removeLoginToken();
    // if (config.domainname == 'localhost') {
    //   document.cookie = config.cookiename + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    // }
    // else {
    //   document.cookie = config.cookiename + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" + config.domainname + ";";
    // }
    SetFormdata(initform);
    dispatch({
      type: LogOut,
    })
    navigate("/");
    toast.success('LogOut Successfully')
    SetPage('login');
    cookies.removeChangeListener(cookieChangeListener)
  }

  const OnBlurFn = (e) => {
    const { id, value } = e.target;
    let error = Validate();
    Object.keys(error).map((currkey) => {
      if (currkey == id || focusedfield.includes(currkey)) {
      }
      else {
        delete error[currkey];
      }
    })
    if (focusedfield?.includes(id)) {
    }
    else {
      SetFocusedField([
        ...focusedfield,
        ...[id],
      ])
    }
    SetError(error);
  }

  const resetTFA = async() => {
    console.log("resetTFA calling");
    
    let Resp;
    try {
      Resp = await userforget2FA(formdata);  
      console.log('forget2FA_resp', Resp);
      if (Resp?.success == 'success') {
          setCounter(120)
          SetPage('Otp');
          SetOTP('');
          SetError({});
          toast.success(Resp.msg, 1000)
          SetDisableStatus({ [Page]: false })

      }
      else {
        SetDisableStatus({ [Page]: false })
        toast.error(Resp?.msg)
        if(Resp?.error){
          SetError(Resp?.error)
        }
      }

    } catch (error) {
      console.log("resetTFA catch error",error);
      
    }
  }

  return (

    <>
      <div className="logindetail">
        <Header />
        <section class="section">
          <div class="container font-md">
            <section class="section banner-login position-relative float-start">
              <div className="box-banner-abs">
                <div className="container">
                  <div className="row align-items-center">
                    <div className="col-xxl-5 col-xl-12 col-lg-12">
                      {
                        Page == "login" ?
                          <div className="box-banner-login">
                            <h2 className="color-brand-1 mb-3">Welcome back</h2>
                            <p className="font-md color-grey-500 mb-4">Fill your email address and password to sign in.</p>

                            <form method="POST" class="row" action="" novalidate="novalidate">

                              <div class="col-lg-12">
                                <div class="form-group mb-4">
                                  <input class={focusedfield?.includes('EmailId') ? (Error?.EmailId ? "form-control icon-user is-invalid" : "form-control icon-user is-valid") : "form-control icon-user"} id="EmailId"  placeholder="Enter Email" name="email" type="email"  onChange={(e) => OnChange(e)} onBlur={(e) => OnBlurFn(e)} />
                                  {Error?.EmailId && <span className="error-msg">{Error.EmailId}</span>}
                                </div>
                              </div>

                              <div class="col-lg-12">
                                <div class="form-group position-relative mb-4">
                                  <input class={focusedfield?.includes('Password') ? (Error?.Password ? "form-control icon-password is-invalid" : "form-control icon-password is-valid") : "form-control icon-password"}  placeholder="Enter Password" name="password" type={passwordType} id="Password" onChange={(e) => OnChange(e)} onBlur={(e) => OnBlurFn(e)} />
                                  <div onClick={togglePassword}>
                                    {passwordType == "text" ? <FaRegEye className="eyepassword" /> :
                                      <FaRegEyeSlash className="eyepassword" />}</div>
                                  {Error?.Password && <span className="error-msg">{Error.Password}</span>}
                                </div>
                              </div>

                              <div class="col-lg-6 col-6 mt-15">
                                <div class="form-group mb-4">
                                  <label class="cb-container">
                                    <input type="checkbox" className="form-check-input" />
                                    <span class="text-small ms-2">Remember me</span><span class="checkmark"></span>
                                  </label>
                                </div>
                              </div>

                              <div class="col-lg-6 col-6 mt-15">
                                <div class="form-group mb-4 text-end">
                                  <Link class="font-xs color-grey-500" to="/forgot">Forgot password?</Link>
                                </div>
                              </div>

                              <div class="col-lg-12 mb-4">
                                <button class="btn btn-brand-lg btn-full font-md-bold" type="button" onClick={() => Loginclick()} disabled={DisableStatus?.[Page]}>Sign in</button>
                              </div>

                            </form>

                            <div class="col-lg-12">
                              <span class="color-grey-500 d-inline-block align-middle font-sm"> Don’t have an account? </span>
                              <Link class="d-inline-block align-middle color-success ms-1" to="/">Sign up now</Link>
                            </div>

                          </div>
                          :
                          ((Page == 'Otp' || Page == 'resend') ?
                            <div className="box-banner-login">
                              <h2 className="color-brand-1 mb-3">Sign In</h2>
                              <p className="font-md color-grey-500 mb-4">Enter OTP sent to {formdata?.EmailId}.</p>

                              <form method="POST" class="row" action="" novalidate="novalidate">

                                <div class="col-lg-12">
                                  <div class="form-group alllogin mb-4">
                                    <OtpInput
                                      value={Otp}
                                      onChange={e=>SetOTP(NumberOnly(e))}
                                      numInputs={4}
                                      renderSeparator={<span>-</span>}
                                      renderInput={(props) => <input {...props} />}
                                      inputStyle={"form-control"}
                                      containerStyle={"justify-content-center"}
                                    />
                                    {Error?.Otp && <span className="error-msg">{Error.Otp}</span>}
                                  </div>
                                </div>
                                <div class="col-lg-12">
                                  <div class="form-group mb-4">
                                    <p className="pr-4"> Otp will expires in <b> {Timer.Minutes}:{Timer.Seconds}</b></p>
                                  </div>
                                </div>
                                <div class="col-lg-12 mb-4">
                                  <button class="btn btn-brand-lg btn-full font-md-bold" type="button" onClick={() => Loginclick()} disabled={DisableStatus?.[Page]}>
                                    { Page == 'Otp' ? "Sign in" : "ReSend-OTP" }
                                  </button>
                                </div>
                                {/* <div class="col-lg-12">
                                                                    <Link class="d-inline-block align-middle color-success ms-1" onClick={()=>{SetPage('login');setCounter(0);SetTimer({Minutes:0,Seconds:0})}}>
                                                                        Sign-in
                                                                    </Link>
                                                                </div> */}
                                <div class="col-lg-12">
                                  <span class="color-grey-500 d-inline-block align-middle font-sm"> Don’t have an account? </span>
                                  <Link class="d-inline-block align-middle color-success ms-1" to="/">Sign up now</Link>
                                </div>
                              </form>
                            </div>
                            :
                            Page == "TFA"
                            ?
                            <div className="box-banner-login">
                              <h2 className="color-brand-1 mb-3">Sign In</h2>
                              <p className="font-md color-grey-500 mb-4">Enter 2FA Code.</p>

                              <form method="POST" class="row" action="" novalidate="novalidate">

                                <div class="col-lg-12">
                                  <div class="form-group alllogin mb-4">
                                    <OtpInput
                                      value={Otp}
                                      onChange={e=>SetOTP(NumberOnly(e))}
                                      numInputs={6}
                                      renderSeparator={<span>-</span>}
                                      renderInput={(props) => <input {...props} />}
                                    />
                                    {Error?.Otp && <span className="error-msg">{Error.Otp}</span>}
                                  </div>
                                </div>
                                <div class="col-lg-12 mb-4">
                                  <button class="btn btn-brand-lg btn-full font-md-bold" type="button" onClick={() => Loginclick()} disabled={DisableStatus?.[Page]}>
                                    Sign in
                                  </button>
                                </div>
                                {/* <div class="col-lg-12">
                                                                    <Link class="d-inline-block align-middle color-success ms-1" onClick={()=>{SetPage('login');setCounter(0);SetTimer({Minutes:0,Seconds:0})}}>
                                                                        Sign-in
                                                                    </Link>
                                                                </div> */}
                                <div class="col-lg-12">
                                  <span class="color-grey-500 d-inline-block align-middle font-sm"> Login with OTP ?</span>
                                  <span class="d-inline-block align-middle color-success ms-1 cursor tft" onClick={resetTFA} >Click now</span>
                                </div>
                                <div class="col-lg-12">
                                  <span class="color-grey-500 d-inline-block align-middle font-sm"> Don’t have an account? </span>
                                  <Link class="d-inline-block align-middle color-success ms-1" to="/">Sign up now</Link>
                                </div>
                              </form>
                            </div>
                            :
                            Page == 'verified' &&
                            <div className="box-banner-login">
                              <h2 className="color-brand-1 mb-3">Log-In Successfully</h2>

                              <form method="POST" class="row" action="" novalidate="novalidate">

                                <div class="col-lg-12">
                                  <button type="button" className="btn btn-brand-lg btn-full font-md-bold" onClick={() => LogOutClick()} disabled={DisableStatus?.[Page]}>
                                    LogOut
                                  </button>
                                </div>
                              </form>
                            </div>
                          )
                      }
                    </div>
                  </div>
                </div>
              </div>

            </section>
          </div>
        </section>

        <Subscriber/>
        {/* <div className="box-newsletter">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5 mt-3 col-md-12">
                <div className="box-image-newsletter">
                  <div className="">
                    <img className="img-main" src={newsletter} alt="Image NewsLetter" />
                    <div className="shape-2 image-1"><img src={logocircle} alt="Icon primary" /></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 mt-3">
                <span className="font-lg color-brand-1">Newsletter</span>
                <h2 className="color-brand-1 mt-2 mb-15">Subscribe our newsletter</h2>
                <p className="font-md color-grey-500">By clicking the button, you are agreeing with our Term & Conditions</p>
                <div className="form-newsletter mt-3 position-relative">
                  <form action="" className="newsletter-form" novalidate="novalidate">
                    <input type="email" name="email" placeholder="Enter your email..."/>
                    <button className="btn btn-submit-newsletter" type="submit">
                      <FaArrowRight />
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div> */}


        <Footer />

      </div>

    </>
  );
}
